export default (): boolean => {
    return typeof (window) !== "undefined" && typeof (window.document) !== "undefined";
};
